// Configuración de URLs de la API
export const API_CONFIG = {
  // URL base para el gateway provider según el entorno
  GATEWAY_PROVIDER_URL: (() => {
    const env = process.env.NEXT_PUBLIC_APP_ENV;
    const customUrl = process.env.NEXT_PUBLIC_GATEWAY_PROVIDER_URL;
    // Preprod es sandbox como staging: mismo gateway provider.
    const isStaging = env === 'staging' || env === 'preprod';

    if (customUrl) {
      return customUrl; // URL personalizada tiene prioridad
    }

    if (env === 'production' || isStaging) {
      return 'https://api.client.gateway.tufirma.digital';
    }

    return '/api'; // En desarrollo usamos el proxy de Next.js
  })(),

  // Timeout para las peticiones de IP
  IP_REQUEST_TIMEOUT: 3000,

  // API key opcional para ipdata.co (fallback)
  IPDATA_API_KEY: process.env.NEXT_PUBLIC_IPDATA_API_KEY || '',

  // Endpoints específicos
  ENDPOINTS: {
    IP: '/ip', // Endpoint completo para producción/staging
  },
} as const;

// URLs completas para los endpoints
export const API_URLS = {
  IP: `${API_CONFIG.GATEWAY_PROVIDER_URL}${API_CONFIG.ENDPOINTS.IP}`,
} as const;
